import { useEffect, useState } from "react";
import "../../Pages/Login/Login.css";
import Instance from "../../Utils/Axios";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import Footer from "./Footer";
import BottomBar from "./BottomBar";

const Layout = ({ children }) => {
  const [highlightData, setHighlightData] = useState({});
  const [faqData, setFaqData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [highlightsRes, faqRes] = await Promise.all([
          Instance.get("/site/highlights"),
          Instance.get("/site/faq")
        ]);
        setHighlightData(highlightsRes.data);
        setFaqData(faqRes.data);
      } catch (err) {
        setError("Error fetching site data");
        console.error("Error fetching layout data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className={`main_content`}>
        <div className={`row main_container`}>
          {children}

          <img
            className={` logo  vector`}
            src="/build/Vector.svg"
            alt="zex pr wire Logo"
            width={250}
            height={300}

          />
          <img
            className={` logo vector_two`}
            src="/build/Vector2.svg"
            alt="zex pr wire Logo"
            width={300}
            height={350}

          />

          <div
            className={`col-12 col-lg-6 d-flex justify-content-center align-items-center flex-column feature-column`}
          >
            <div className={`features`}>
              {highlightData.highlights &&
                highlightData.highlights.desc.map((item, index) => (
                  <div key={index}>
                    {index === 0 && (
                      <div className={"feature_one"}>
                        <h5>{item.title}</h5>
                        <div>{parse(item.desc)}</div>
                      </div>
                    )}
                    {index === 1 && (
                      <div className={"feature_two"}>
                        <img
                          className={`logo ${item.iconClass}`}
                          src={item.iconUrl}
                          alt="zex pr wire Logo"
                          width={24}
                          height={24}

                        />
                        <h5>{item.title}</h5>
                        <div>{parse(item.desc)}</div>
                      </div>
                    )}
                    {index === 2 && (
                      <div className={"feature_three"}>
                        <h5>
                          <span>{item.title}</span>
                        </h5>
                        <div>{parse(item.desc)}</div>
                      </div>
                    )}
                    {index === 3 && (
                      <div className={"feature_four"}>
                        <img
                          className={`logo ${item.iconClass}`}
                          src={item.iconUrl}
                          alt="zex pr wire Logo"
                          width={24}
                          height={24}

                        />
                        <h5>{item.title}</h5>
                        <div>{parse(item.desc)}</div>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="info_wrapper py-5" style={{ background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
          <div className="row justify-content-between">
            {/* Left: Introduction */}
            <div className="col-lg-5 mb-4 mb-lg-0">
              {/* <img
                src="/build/Logo.svg"
                alt="zex pr wire Logo"
                width={150}
                height={60}
                className="mb-4"
              /> */}
              <h5 className="mb-4" style={{ fontWeight: '600', fontSize: '20px', lineHeight: '1.5', color: '#1a1a1a' }}>
                ZEX PR Wire offers massive Press Release, News, Authored Articles,
                Editorial services, geared at generating massive exposure for your
                unique project, business, or concept.
              </h5>
              <p className="mb-4" style={{ fontWeight: '500', fontSize: '15px', lineHeight: '1.5', color: '#666' }}>
                ZEX PR WIRE is a premium press release distribution provides
                end-to-end solutions to produce, optimize and target content and
                then distribute and measure results. Combining the world's largest
                multi-channel, multi-cultural content distribution and
                optimization network with comprehensive workflow tools and
                platforms, ZEX PR WIRE serves tens of thousands of clients from
                offices in the Americas, Europe, Middle East, Africa and
                Asia-Pacific regions.
              </p>
            </div>

            {/* Right: FAQs */}
            <div className="col-lg-6">
              <h4 className="mb-4" style={{ fontWeight: '700', fontSize: '24px' }}>FAQs</h4>
              <div className="faq_content">
                <style>{`
                  .faq-item:hover p { color: #595fde !important; }
                  .faq-item:hover { cursor: pointer; }
                `}</style>
                {faqData?.faq?.desc?.map((faqItem, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center py-2 faq-item"
                    style={{ borderBottom: '1px solid #eee' }}
                  >
                    <p className="mb-0" style={{ fontSize: '15px', fontWeight: '500', color: '#333', transition: 'color 0.2s' }}>
                      {faqItem.title}
                    </p>
                    <img
                      src={faqItem.iconUrl || "/build/arrownw.svg"}
                      alt="Arrow"
                      width={18}
                      height={18}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <BottomBar />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Layout;
